import { RenderItemFormSidebarPanelCtx } from "datocms-plugin-sdk";
import { Canvas, TextInput, Button } from "datocms-react-ui";
import { useState } from "react";

type Props = {
  ctx: RenderItemFormSidebarPanelCtx,
};

function RenderWebshopArticleSidePanel({ ctx }: Props) {
  const [windowWidth, setWindowWidth] = useState<string>("414");
  const [windowHeight, setWindowHeight] = useState<string>("896");

  const itemId = ctx.item?.id;
  console.log(ctx.item)
  return (
    <Canvas ctx={ctx}>
      <div>
        Window width:
        <TextInput
          value={windowWidth}
          onChange={setWindowWidth}
          labelText="Window width"
        /><br/>

        Window height:
        <TextInput
          value={windowHeight}
          onChange={setWindowHeight}
        /><br/>

        <Button 
          onClick={() => {
          ctx.openModal({
            id: 'renderWebshopArticle',
            title: 'Rendering current webshop article',
            width: 'l',
            parameters: {
              id: itemId,
              width: Number(windowWidth),
              height: Number(windowHeight),
              content: ctx.formValues,
            },
          });
        }}>Render webshop article</Button>
      </div>
    </Canvas>
  );
};

export default RenderWebshopArticleSidePanel;